import './App.css';
import { Home } from './components/Home';
import { Nav } from './components/Nav';
import "./App.css"



function App() {
  return (
    <div id='app-container'>
        <Nav/>
        <Home/>
    </div>
  );
}

export default App;
